<template>
    <div class="container-fluid w-v bg-white">
        <div class="row full-height">
            <div class="col-lg-6 d-flex flex-column align-items-center text-color m-auto bg-white"
                 style="height: 100vh; padding-top: 10rem">
                <div class="login-brand mb-2">
                    <img :src="statics.logo"
                         alt="."/>
                </div>
                <div class="my-4 text-center">
                    <p class="mb-1">Welcome {{ auth.user.profile.first_name }}! You have multiple accounts.</p>
                    <p>Please choose the account you want to proceed with.</p>
                </div>
                <el-button class="mb-2 ml-0 lead"
                           v-for="access in accesses"
                           :key="access.company_id"
                           v-if="access.enabled && access.company.enabled"
                           @click="companyLogin(access)">
                    <b>{{ access.company.name }}</b>
                </el-button>
                <el-button class="mt-4 ml-0"
                           type="danger"
                           plain
                           v-if="isAdminImpersonating()"
                           @click="stopAdminImpersonation">
                    <i class="fa fa-user-secret"></i>
                    Stop Impersonating
                </el-button>
                <el-button class="mt-4 ml-0"
                           type="danger"
                           plain
                           v-if="!isAdminImpersonating()"
                           @click="logOut">
                    <i class="fa fa-sign-out"></i>
                    Log Out
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import auth from '../auth'
import {acl_mixin, helper_mixin} from '../mixins'
import {mapActions} from 'vuex'
import {getCookie, setCookie, isImpersonating, isAdminImpersonating} from '../../utils/functions'

export default {
    mixins: [acl_mixin, helper_mixin],
    data() {
        return {
            auth: auth,
            accesses: [],
            statics: {
                logo: null,
                logo_inverse: null,
                logo_square: null,
                logo_square_inverse: null,
                host: null,
                referer: null,
                name: null,
                domain: null,
                whitelabel: false,
                path: null
            },
        }
    },

    mounted() {
        this.auth.user.authenticated = false
        this.accesses = this.auth.user.profile.user_accesses
    },

    created() {
        this.getStatics()
        this.getAccesses()
    },

    methods: {
        getAccesses() {
            axios.get('/api/v1/user/company/accesses')
                .then(res => {
                    this.accesses = res.data
                })
                .catch(err => {
                    console.log(err)
                    this.$root.handleErrors(err.response)
                })
        },

        getStatics() {
            axios.get('/get-statics')
                .then(res => {
                    this.statics = res.data
                    this.setPageTitle('Select Company - ' + this.statics.name)
                })
                .catch(err => {
                    this.setPageTitle('Select Company - Aloware')
                    console.log(err)
                    this.$root.handleErrors(err.response)
                })
        },

        loginWithSavedCompany () {
            const selectedCompanyId = parseInt(getCookie('selected_company_id'))

            if (!selectedCompanyId) {
                return
            }

            const selectedCompany = this.accesses.find(access => access.company_id === selectedCompanyId)
            if (selectedCompany) {
                this.companyLogin(selectedCompany)
            }
        },

        companyLogin(access) {
            const currentCompanyId = parseInt(localStorage.getItem('company_id'))

            // Already on this company — just save preference and continue
            if (currentCompanyId === access.company_id) {
                if (this.accesses?.length > 1) {
                    setCookie('selected_company_id', access.company_id, 30)
                }
                window.location.href = '/'
                return
            }

            this.logoutUser()

            this.auth.switchCompany(access.id).then(res => {
                if (this.accesses?.length > 1) {
                    setCookie('selected_company_id', access.company_id, 30)
                }
                window.location.href = '/'
            })
        },

        isImpersonating,
        isAdminImpersonating,

        stopAdminImpersonation() {
            this.auth.stopImpersonation().then(() => {
                window.location.href = '/admin'
            })
        },

        logOut() {
            setCookie('selected_company_id', '', -1)
            this.auth.logout(false).finally(() => {
                this.logoutUser()
                window.location.href = '/login'
            })
        },

        ...mapActions(['logoutUser'])
    },

    beforeRouteEnter(to, from, next) {
        auth.check(false, false).then((res) => {
            if (!res.data.user.has_multiple_access) {
                next({name: 'Dashboard'})
                return
            }

            // Skip auto-select for manual navigation (header "Select Account" link)
            if (to.query.manual) {
                next()
                return
            }

            // Try auto-select from saved cookie
            const selectedCompanyId = parseInt(getCookie('selected_company_id'))
            if (!selectedCompanyId) {
                next()
                return
            }

            // Fetch accesses and auto-login with saved company
            axios.get('/api/v1/user/company/accesses').then(accessRes => {
                const selectedCompany = accessRes.data.find(
                    access => access.company_id === selectedCompanyId
                )
                if (selectedCompany) {
                    auth.switchCompany(selectedCompany.id).then(() => {
                        setCookie('selected_company_id', selectedCompany.company_id, 30)
                        window.location.href = '/'
                    }).catch(() => next())
                } else {
                    next()
                }
            }).catch(() => next())
        }).catch((err) => {
            next({name: 'Login', query: {redirect: to.fullPath}})
        })
    }
}
</script>
